export interface IQuestion {
  id: string; // MongoDB document id of the question
  key: string; // Unique key (string) for the question
  label: string; // Label of the questions
  placeholder?: string; // only applies to text based questions
}

export enum QType {
  five_star_select = 'five_star_select',
  textbox = 'textbox',
  autosuggest = 'autosuggest',
}

export interface IFormattedResponse {
  questionId: string;
  answers: string[];
}

export interface IReviewPayload {
  entityType: string;
  entityValue: string;
  responses: IFormattedResponse[];
  reviewCategory: string;
  surveyId: string;
  source?: string;
  updateReviews?: boolean;
}

export interface IQuestionAnswerMap {
  [questionId: string]: string;
}
